<template>
    <DCard padding>
        <DTable
            :items="incidentValues.data"
            :fields="[
                {key: 'incident_type', label: __('settings.lov_incidents.table.incident_type')},
                {key: 'customer_request', label: __('settings.lov_incidents.table.customer_request')},
                {key: 'incident_solution', label: __('settings.lov_incidents.table.incident_solution')},
                {key: 'actions', label: '', sorter: false}
            ]"
        >
            <template #incident_type="{item}">
                <td>
                    {{ item.name }}
                </td>
            </template>
            <template #customer_request="{item}">
                <td>
                    <ul class="ul-class">
                        <li
                            v-for="(customerRequest, index) in item.business_incident_customer_request"
                            :key="index"
                            class="pb-2 pl-0"
                        >
                            {{ customerRequest.name }}
                        </li>
                    </ul>
                </td>
            </template>
            <template #incident_solution="{item}">
                <td>
                    <ul class="ul-class">
                        <li
                            v-for="(incidentSolution, index) in item.business_incident_solution"
                            :key="index"
                            class="pb-2 pl-0"
                        >
                            {{ incidentSolution.name }}
                        </li>
                    </ul>
                </td>
            </template>
            <template #actions="{item}">
                <td>
                    <div class="buttons">
                        <DButton
                            :id="`edit_${item.id}`"
                            icon="pencil"
                            mini
                            @click="$inertia.get(editIncidentValues(item.id))"
                        />
                        <DButton
                            v-if="item.can_be_deleted"
                            :id="`delete_${item.id}`"
                            icon="trash-can-outline"
                            color="danger"
                            mini
                            @click="openDeleteModal(item)"
                        />
                    </div>
                </td>
            </template>
        </DTable>
        <DPagination
            v-if="incidentValues.last_page > 1"
            :active-page="incidentValues.current_page"
            :pages="incidentValues.last_page"
            align="center"
            @update:activePage="changePage"
        />

        <DFabs>
            <DFab
                id="btn-add"
                icon="plus"
                :label="__('settings.lov_incidents.add_incident')"
                @click="addIncidentValues"
            />
        </DFabs>

        <DModal
            :show="selectedItem !== null"
            :title="__('settings.lov_incidents.modals.deletion.title')"
            :message="__('settings.lov_incidents.modals.deletion.message')"
            confirm-button-text="messages.delete"
            is-confirm
            is-error
            @close="closeDeleteModal"
            @confirm="confirmDelete"
        />
    </DCard>
</template>

<script>
import App from '~@/App.vue'
import { ref } from 'vue'
import { router } from '@inertiajs/vue3'
import { route } from '~@/Composables/route'
import LovLayout from '~@/Pages/Settings/Lov/LovLayout.vue'

export default {
    layout: [App, LovLayout]
}
</script>

<script setup>

defineProps({
    incidentValues: {
        type: Object,
        default: () => {
            return {}
        }
    }
})

const addIncidentValues = () => router.get(route('settings.incident-values.create'))

const changePage = (page) => {
    const queryParameters = {}

    if (page > 1) {
        queryParameters.page = page
    }

    router.get(route('settings.incident-values.index'), queryParameters)
}

const editIncidentValues = (id) => route('settings.incident-values.edit', { incident_value: id })

const selectedItem = ref(null)

const openDeleteModal = (item) => {
    selectedItem.value = item
}

const closeDeleteModal = () => {
    selectedItem.value = null
}

const confirmDelete = () => {
    router.delete(route('settings.incident-values.destroy', { incident_value: selectedItem.value.id }), {
        preserveScroll: true
    })
}

</script>

<style lang="scss" scoped>
.ul-class{
    margin: 0;
    padding-left: 15px;
}
.buttons {
    display: flex;
    grid-gap: 10px;
}
</style>
